var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as CMP from "../../components";
import * as RenderMethods from "../LiveStreamElements";
/* istanbul ignore next */
var LeagueItem = /** @class */ (function (_super) {
    __extends(LeagueItem, _super);
    function LeagueItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLiveStreamLabel = RenderMethods.renderLiveStreamLabel;
        _this.renderLiveStreamIcon = RenderMethods.renderLiveStreamIcon;
        return _this;
    }
    LeagueItem.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-league-list__item-holder", "data-uat": "div-league-list-item-holder" },
            React.createElement("div", { className: "rj-league-list__item", "data-uat": "div-league-list-item" },
                this.props.showCheckbox &&
                    React.createElement(CMP.Checkbox, { id: "rj-league-list__item-" + this.props.league.id, leagueId: this.props.league.id, checked: this.props.league.isSelected, sportId: this.props.league.sportId, onChange: this.props.toggleSelectedLeague, tooltipMessage: this.props.tooltipMessage, showTooltip: this.props.showTooltip, selectedLeagueId: this.props.selectedLeagueId }),
                React.createElement("a", { href: this.props.league.linkUrl, onClick: function (e) { return _this.props.openLeagueTranspiler(_this.props.league.sportId, _this.props.league.id, e, e.target); }, className: "rj-league-list__item-link", "data-uat": "a-league-list-item-link" },
                    React.createElement("span", { className: "rj-league-list__item-title", "data-uat": "span-league-list-item-title" }, this.props.league.name),
                    React.createElement("div", { className: "rj-league-list__live-stream-elements-wrap", "data-uat": "div-league-list-live-stream-elements-wrap" },
                        this.renderLiveStreamIcon(this.props.league.hasLiveStreaming, this.props.dict.LiveSteaming),
                        this.renderLiveStreamLabel(this.props.league.hasLiveEvents, this.props.dict.LiveLabel))))));
    };
    return LeagueItem;
}(React.Component));
export { LeagueItem };
//# sourceMappingURL=LeagueItem.js.map